// src/components/blog/BlogPostSkeleton.jsx

import React, { memo } from 'react';

const BlogPostSkeleton = memo(({ isDark }) => {
  return (
    <div className={`pt-20 min-h-screen ${isDark ? 'bg-black' : 'bg-white'}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Back button skeleton */}
        <div className="w-32 h-6 bg-gray-200 dark:bg-gray-800 rounded mb-6 animate-pulse" />
        
        {/* Header skeleton */}
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-20 h-6 bg-gray-200 dark:bg-gray-800 rounded-full animate-pulse" />
            <div className="w-16 h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" />
          </div>
          <div className="w-3/4 h-12 bg-gray-200 dark:bg-gray-800 rounded mb-4 animate-pulse" />
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gray-200 dark:bg-gray-800 rounded-full animate-pulse" />
            <div className="flex-1">
              <div className="w-32 h-4 bg-gray-200 dark:bg-gray-800 rounded mb-2 animate-pulse" />
              <div className="w-48 h-3 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" />
            </div>
          </div>
        </div>
        
        {/* Image skeleton */}
        <div className="w-full h-96 bg-gray-200 dark:bg-gray-800 rounded-2xl mb-8 animate-pulse" />
        
        {/* Content skeleton */}
        <div className="space-y-4">
          <div className="w-full h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" />
          <div className="w-11/12 h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" />
          <div className="w-full h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" />
          <div className="w-10/12 h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" />
          <div className="w-3/4 h-8 bg-gray-200 dark:bg-gray-800 rounded mt-6 mb-4 animate-pulse" />
          <div className="w-full h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" />
          <div className="w-11/12 h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" />
          <div className="w-full h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
});

BlogPostSkeleton.displayName = 'BlogPostSkeleton';

export default BlogPostSkeleton;